import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=755e591b&scoped=true&"
import script from "./Error.vue?vue&type=script&lang=js&"
export * from "./Error.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/error.css?vue&type=style&index=0&id=755e591b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755e591b",
  null
  
)

export default component.exports